module.exports = __webpack_public_path__ + "media/images/YardStick-logo-alternate-onecolor-wheatfieldyellow-noslogan-8412145734dd32e6971153c9ab1af078.png";